import { AddTemplateModal } from './AddTemplateModal';

export default AddTemplateModal;
